import { GET_PLC_SAFETY_EVENTS, GET_PLC_SAFETY_EVENTS_SUCCESS, GET_PLC_SAFETY_EVENTS_ERROR } from './actionTypes';

const initialState = {
  errorGetPlcSafetyEvents: '',
  loadingGetPlcSafetyEvents: false,
  events: null,
};

const getEvents = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_EVENTS:
      state = { ...state, loadingGetPlcSafetyEvents: true };
      break;
    case GET_PLC_SAFETY_EVENTS_SUCCESS:
      state = { ...state, loadingGetPlcSafetyEvents: false, events: action.payload.events };
      break;
    case GET_PLC_SAFETY_EVENTS_ERROR:
      state = { ...state, errorGetPlcSafetyEvents: action.payload, loadingGetPlcSafetyEvents: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getEvents;
